import {HttpConfig, HttpResponse} from "@/Fwk/Http/HttpConfig";
import {comRequest} from "@/Fwk/Http/comRequest";
import RequestMgr, {NetType} from "@/Fwk/Http/RequestMgr";
import {
    GetUserLatestOrdersResponse,
    ShopItemsListResponse,
    QueryOrderResponse,
    XtgConfigListResponse,
    XtgLinkResponse
} from "./types/store";
import BigTips from "@/Master/BigTips";
import Toast from "../_components/Toast";

export async function getPaymentItems(params: object = {}): Promise<ShopItemsListResponse> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.PaymentItemsList),
        method: 'POST',
        body: params,
    };
    const request = await DoSendRequest<ShopItemsListResponse>(config);
    if (request.code == 200 && request.data) {
        return request.data;
    }else{
        return {} as ShopItemsListResponse;
    }
}

export async function getXtgConfig(params: object = {}): Promise<XtgConfigListResponse> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.GetXtgConfig),
        method: 'POST',
        body: params,
    }
    const request = await DoSendRequest<XtgConfigListResponse>(config);
    if (request.code == 200 && request.data) {
        return request.data;
    }else{
        BigTips.showMsg(request.message);
        Toast.show(request.message)
        return {} as XtgConfigListResponse;
    }
}

export async function getXtgLink(params: object = {}): Promise<XtgLinkResponse> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.GetXtgLink),
        method: 'POST',
        body: params,
    }

    const request = await DoSendRequest<XtgLinkResponse>(config);
    if (request.code == 200 && request.data) {
        return request.data;
    }else{
        Toast.show(request.message);
    }
    return request.data;
}

//查询支付订单接口
export async function queryOrder(params: object = {}): Promise<QueryOrderResponse> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.QueryOrder),
        method: 'POST',
        body: params,
    }
    const request = await DoSendRequest<QueryOrderResponse>(config);
    if (request.code == 200 && request.data) {

    }else{
        Toast.show(request.message);
    }
    return request.data;
}

//获取用户上一次订单接口
export async function getUserLatestOrder(params: object = {}): Promise<GetUserLatestOrdersResponse> {
    const config: HttpConfig = {
        url: RequestMgr.getUrl(NetType.GetUserLatestOrders),
        method: 'POST',
        body: params,
    }
    const request = await DoSendRequest<GetUserLatestOrdersResponse>(config);
    if (request.code == 200 && request.data) {

    }else{
        Toast.show(request.message);
    }
    return request.data;
}


export async function DoSendRequest<T>(config: HttpConfig): Promise<HttpResponse<T>> {
    config.isSerErrTips = true;
    const sendRequest = await comRequest<T>(config);
    return sendRequest;
}
